module.exports = __webpack_public_path__ + "static/media/02.6fff3fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/02.jpg
// module id = 177
// module chunks = 0